import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import mixpanel from 'mixpanel-browser';
import { MixpanelProvider, MixpanelConsumer } from 'react-mixpanel';
// mixpanel.init('12ddb74c280e0fd6e0abe9c7ce0dc39c'); // test

// looqme
mixpanel.init('0dceb3a9eea234bf236d0cc89effa65d');

ReactDOM.render(
  <MixpanelProvider mixpanel={mixpanel}>
    <MixpanelConsumer>
      {mixpanel => <App mixpanel={mixpanel} />}
    </MixpanelConsumer>
  </MixpanelProvider>,
  document.getElementById('root')
);
